import type { NewBillingCycle } from '@weft/types';
import { BILLING_CYCLE_STATUSES } from '@weft/types';

export const NewBillingCycleInitialValues: NewBillingCycle = {
  name: '',
  billingDay: 1,
  customersIds: [],
  status: BILLING_CYCLE_STATUSES.Active,
};